export default "/images/opencdljobs.png?c1beeb2dd517a6ce49bd0a7305bbee3b";